export default function getReverseMap(obj) {
  return Object.keys(obj).reduce(
    (reverse, key) =>
      Object.assign(reverse, {
        [obj[key]]: (reverse[obj[key]] || []).concat(key),
      }),
    {}
  );
}
